// extracted by mini-css-extract-plugin
export var createdDate = "_l1-1";
export var divider = "_l1-2";
export var headerDivider = "_l1-3";
export var messagesCard = "_l1-0";
export var messagesContainer = "_l1-7";
export var messagesContainerWrapper = "_l1-4";
export var pointerCapturingButtonBoxes = "_l1-a";
export var showLeftPanelButton = "_l1-9";
export var showMoreButton = "_l1-c";
export var showMoreButtonContainer = "_l1-b";
export var summaryTitle = "_l1-6";
export var systemMessageCardWrapper = "_l1-d";
export var topButtons = "_l1-8";
export var withPadding = "_l1-5";